import { fieldLogFootageStatusFilterSchema } from '@/features/field-log/lib/footageReview';
import { SUPERVISOR_TABS } from '@/features/supervisor/config/constants';
import { z } from 'zod';

export const supervisorOverviewSearchSchema = z
  .object({
    organizationId: z.array(z.string().min(1)).optional().catch(undefined),
    projectId: z.string().min(1).optional().catch(undefined),
    dateFrom: z.string().date().optional().catch(undefined),
    dateTo: z.string().date().optional().catch(undefined),
  })
  .strip();

export const supervisorActivitySearchSchema = z
  .object({
    organizationId: z.array(z.string().min(1)).optional().catch(undefined),
    projectId: z.string().min(1).optional().catch(undefined),
    dateFrom: z.string().date().optional().catch(undefined),
    dateTo: z.string().date().optional().catch(undefined),
    tab: z.enum(SUPERVISOR_TABS).optional().catch(undefined),
    runner: z.array(z.string().min(1)).optional().catch(undefined),
    opsCode: z.array(z.string().min(1)).optional().catch(undefined),
    operatorPresence: z.enum(['present', 'missing']).optional().catch(undefined),
    footageStatus: fieldLogFootageStatusFilterSchema,
    recording: z.boolean().optional().catch(undefined),
    environmentId: z.string().min(1).optional().catch(undefined),
    operatorId: z.string().min(1).optional().catch(undefined),
    q: z.string().optional().catch(undefined),
  })
  .strip();

export const supervisorCamerasSearchSchema = z
  .object({
    organizationId: z.array(z.string().min(1)).optional().catch(undefined),
    dateFrom: z.string().date().optional().catch(undefined),
    dateTo: z.string().date().optional().catch(undefined),
    status: z
      .enum([
        'onboarding',
        'active',
        'inactive',
        'under-calibration',
        'sent-for-repair',
        'broken',
        'replaced',
        'unknown',
      ])
      .optional()
      .catch(undefined),
    q: z.string().optional().catch(undefined),
  })
  .strip();

export function normalizeSupervisorSearch(value: string | null | undefined): string | undefined {
  return value?.trim() || undefined;
}
